import { memo, useEffect } from 'react';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';

import {
  openSectionCommentPanel,
  shouldScrollInToView,
} from 'src/ddvComment/directUser/utils';

function EmptyCommentAnchor({ children, setCommentAnchorId, anchorId }) {
  useEffect(() => {
    if (anchorId) {
      setCommentAnchorId(anchorId);
    }
  }, [anchorId]);
  return children || null;
}

export default CommentAnchor(memo(EmptyCommentAnchor), {
  shouldScrollInToView: (anchorRecord, anchorId) =>
    anchorRecord?.componentName === anchorId ||
    anchorRecord?.identifier === anchorId,
  getAnchorIdFromProp({ anchorId }) {
    return anchorId;
  },
  // onDirectSuccess: openSectionCommentPanel,
});
